import { DeferredPage } from "@/components/data-display/deferred-page";

// Deferred (page-delivery-pipeline.md G6, 2026-09-23). No treasury backend exists in this
// environment: the calendar's upcoming events (maturities, unstaking, settlements) were
// previously fabricated. See context/page_pipeline/BOARD.md wave 4 and
// context/page_pipeline/BACKEND_GAPS.md.
export default function TreasuryCalendarPage() {
  return (
    <DeferredPage
      nav={{ kind: "header", title: "Treasury Calendar", subtitle: "Upcoming maturity, unstaking, settlement, review, and repayment events." }}
      state={{
        title: "Treasury Calendar is not available in this environment yet",
        description: "Upcoming treasury events such as maturities, unstaking windows, and settlements have no backend in this environment yet. This page will show real events once the treasury domain is built.",
      }}
    />
  );
}
